
    // this file was auto generated by python script
    import Mail from './Mail';
    export default Mail;
    